import { User } from '../variables/types';

const getFullName = (user: User) => `${user?.firstName} ${user?.lastName}`;

export default getFullName;
